module.exports = __webpack_public_path__ + "body-special-bg-shape-02.png?bb44bef037fe9823335854d2d6057ace";